module.exports = __webpack_public_path__ + "img/DK17616617.574d9959.png";